import './css/Input.css'
export const Input = (props) => {

    return (
        props.f(props.param.type, false, 0, props.param)
    )

}